/* Nutty — poklon uz narudžbu (16.9.2026)

   Proizvod iz metaobjekta "Poklon uz narudžbu" (tip poklon_akcija) sam se
   dodaje u svaku košaricu koja ima barem jedan plaćeni proizvod, u količini 1.

   Kada vrijedi — odlučuje se ovdje, po satu u pregledniku, jer Shopify
   stranice mogu biti keširane pa Liquidov 'now' nije pouzdan:
     Uključeno = da  I  početak <= sada < kraj  I  poklon ima zalihe.
   Prazan početak = odmah, prazan kraj = bez kraja. Ako je uključeno više
   zapisa, vrijedi prvi čije je razdoblje u tijeku.

   Pravila za košaricu:
     - ima plaćenih stavki + akcija traje  -> točno 1 kom poklona
     - nema plaćenih stavki / akcija ne traje / nema zalihe -> poklona nema
     - poklon iz neke druge (stare) akcije -> miče se

   Konfiguraciju i trenutno stanje košarice ispisuje
   snippets/nutty-poklon-config.liquid u window.NuttyPoklon. Prikaz poklona u
   košarici (bez količine, bez brisanja, bez linka) je u nutty-cart-packs.liquid.

   Info box na PDP-u (snippets/nutty-poklon-info.liquid, iz buy-buttons) se prikaže pri
   učitavanju; ovdje ga samo pali/gasi kad akcija krene ili završi dok je
   stranica otvorena, i nakon promjene varijante (morph mu vrati 'hidden'). */

import { sectionRenderer } from '@theme/section-renderer';

const CFG = window.NuttyPoklon || {};
const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
const SOURCE = 'nutty-poklon';
const CAMPAIGNS = (CFG.campaigns || []).filter((c) => c && c.variantId);
const GIFT_IDS = new Set(CAMPAIGNS.map((c) => Number(c.variantId)));

let timer = null;
let running = null;
let again = false;

/* ---------- pravila ---------- */

function activeCampaign(now = Date.now()) {
  return (
    CAMPAIGNS.find(
      (c) => c.enabled && c.available && (!c.start || now >= c.start) && (!c.end || now < c.end)
    ) || null
  );
}

function isGiftLine(line) {
  return GIFT_IDS.has(Number(line.variant_id)) || !!(line.properties && line.properties._poklon);
}

/** Što treba promijeniti da košarica odgovara pravilima. */
function plan(lines) {
  const campaign = activeCampaign();
  const hasPaid = lines.some((l) => !isGiftLine(l));
  const want = campaign && hasPaid ? Number(campaign.variantId) : 0;
  const updates = {};
  let kept = false;

  lines.filter(isGiftLine).forEach((l) => {
    if (want && Number(l.variant_id) === want && !kept) {
      kept = true;
      if (l.quantity !== 1) updates[l.key] = 1;
    } else {
      updates[l.key] = 0;
    }
  });

  return { updates, add: want && !kept ? want : 0 };
}

function needsWork(p) {
  return !!p.add || Object.keys(p.updates).length > 0;
}

/* ---------- košarica ---------- */

function post(path, body) {
  return fetch(ROOT + path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  }).then((r) => {
    if (!r.ok) throw new Error(path + ' ' + r.status);
    return r.json();
  });
}

function rerender() {
  const ids = new Set();
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
    if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
  });
  ids.forEach((id) => {
    sectionRenderer.renderSection(id, { cache: false }).catch(() => {});
  });
}

async function reconcile() {
  const cart = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const p = plan(cart.items || []);
  if (!needsWork(p)) return;

  if (Object.keys(p.updates).length) {
    await post('cart/update.js', { updates: p.updates });
  }
  if (p.add) {
    try {
      await post('cart/add.js', { items: [{ id: p.add, quantity: 1, properties: { _poklon: '1' } }] });
    } catch (e) {
      /* npr. zaliha je upravo pala na 0 — košarica ostaje bez poklona */
      console.warn('[nutty-poklon] poklon nije dodan', e);
    }
  }
  rerender();
}

function sync() {
  clearTimeout(timer);
  timer = null;
  if (running) {
    again = true;
    return running;
  }
  running = reconcile()
    .catch((e) => console.warn('[nutty-poklon]', e))
    .finally(() => {
      running = null;
      if (again) {
        again = false;
        schedule();
      }
    });
  return running;
}

function schedule(delay = 300) {
  clearTimeout(timer);
  timer = setTimeout(sync, delay);
}

/* ---------- info box na PDP-u ---------- */

function updateInfo() {
  const now = Date.now();
  document.querySelectorAll('.npi-wrap').forEach((wrap) => {
    let shown = false;
    wrap.querySelectorAll('[data-npk-info]').forEach((box) => {
      const start = Number(box.dataset.start) || 0;
      const end = Number(box.dataset.end) || 0;
      const on = !shown && (!start || now >= start) && (!end || now < end);
      box.hidden = !on;
      if (on) shown = true;
      if (end) {
        box.querySelectorAll('[data-npi-end]').forEach((el) => {
          el.textContent = new Date(end).toLocaleDateString('hr-HR', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric',
          });
        });
      }
    });
  });
}

document.addEventListener('variant:update', () => {
  setTimeout(updateInfo, 150);
  setTimeout(updateInfo, 600);
});

/* ---------- okidači ---------- */

// svaka promjena košarice (Horizon, Nutty skripte, drawer)
document.addEventListener('cart:update', (event) => {
  if (event.detail && event.detail.data && event.detail.data.source === SOURCE) return;
  schedule();
});

// odlazak na checkout ne smije preteći dodavanje poklona
document.addEventListener(
  'click',
  (event) => {
    if (!timer && !running) return;
    const t = event.target;
    const btn = t && t.closest ? t.closest('[name="checkout"], a[href$="/checkout"]') : null;
    if (!btn) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    sync().then(() => {
      window.location.href = ROOT + 'checkout';
    });
  },
  true
);

// akcija počinje ili završava dok je stranica otvorena
function armBoundary() {
  const now = Date.now();
  let next = Infinity;
  CAMPAIGNS.forEach((c) => {
    if (!c.enabled) return;
    [c.start, c.end].forEach((t) => {
      if (t && t > now && t < next) next = t;
    });
  });
  const wait = next - now;
  if (wait < 24 * 60 * 60 * 1000) {
    setTimeout(() => {
      sync();
      updateInfo();
      armBoundary();
    }, wait + 1000);
  }
}

// kod učitavanja stranice diraj košaricu samo ako stvarno ne odgovara pravilima
const initialLines = (CFG.cartLines || []).map((l, i) => ({
  key: 'init-' + i,
  variant_id: l[0],
  quantity: l[1],
  properties: l[2] ? { _poklon: '1' } : {},
}));
if (needsWork(plan(initialLines))) schedule(0);
updateInfo();
armBoundary();
